import { render, staticRenderFns } from "./pca.vue.pug?vue&type=template&id=70a36e1c&lang=pug&"
import script from "./pca.vue.js?vue&type=script&lang=js&"
export * from "./pca.vue.js?vue&type=script&lang=js&"
import style0 from "./pca.vue.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports